import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { DsTableComponent } from "./ds-table.component";
import { MatTableModule } from "@angular/material/table";
import { MatSortModule } from "@angular/material/sort";
import { DsColumnComponent } from "./ds-column/ds-column.component";
import { DsExpandRowComponent } from "./ds-expand-row/ds-expand-row.component";
import { DsIconModule } from "../ds-icon/ds-icon.module";

@NgModule({
  declarations: [DsTableComponent, DsColumnComponent, DsExpandRowComponent],
  imports: [CommonModule, MatTableModule, MatSortModule, DsIconModule],
  exports: [DsTableComponent, DsColumnComponent, DsExpandRowComponent, MatTableModule, MatSortModule],
})
export class DsTableModule {}
